import { ToDevigner, ToStudio } from 'dragonmouse-shared/interfaces';
import { VITE_FORGE_URL } from './constants';

export function isForgeOrigin(event: MessageEvent): boolean {
	// Extract base origin from VITE_FORGE_URL (e.g., "https://localhost:8443/api" -> "https://localhost:8443")
	const forgeBaseOrigin = new URL(VITE_FORGE_URL).origin;
	return forgeBaseOrigin === event.origin;
}

export function sendToDevigner(
	iframe: HTMLIFrameElement | null,
	siteId: string,
	toDevigner: {
		type: ToDevigner['type'];
		[key: string]: any;
	}
): void {
	if (!iframe?.contentWindow) return;
	iframe.contentWindow.postMessage({ ...toDevigner, siteId } as ToDevigner, VITE_FORGE_URL);
}

export function onToStudio(
	iframe: HTMLIFrameElement | null,
	siteId: string,
	handler: (toStudio: ToStudio) => void
): () => void {
	const listener = (event: MessageEvent) => {
		// Only handle messages from the correct iframe and site
		if (!isForgeOrigin(event)) return;
		if (event.source !== iframe?.contentWindow) return;
		if (event.data?.siteId !== siteId) return;

		// Type guard to ensure it's a ToStudio message
		const toStudio = event.data as ToStudio;
		if (toStudio && typeof toStudio.type === 'string' && toStudio.siteId === siteId) {
			handler(toStudio);
		}
	};

	window.addEventListener('message', listener);
	return () => window.removeEventListener('message', listener);
}

